/**
 * Browser page translation (Chrome's Google Translate) and some extensions replace the text nodes React rendered with
 * their own `<font>` wrappers. When React later updates that text it removes or inserts around a node that is no
 * longer where it left it, the DOM throws `NotFoundError`, and the whole page falls to the error boundary. Skipping the
 * one stale operation leaves the translated text in place, which is what the shopper is reading anyway.
 * https://github.com/facebook/react/issues/11538#issuecomment-417504600
 */
if (typeof Node === 'function' && Node.prototype) {
  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      return child;
    }
    return removeChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function <T extends Node>(this: Node, node: T, child: Node | null): T {
    if (child && child.parentNode !== this) {
      return node;
    }
    return insertBefore.call(this, node, child) as T;
  };
}

export {};
